export default function CCompiler() {
  return <h2>C Compiler</h2>;
}
